module.exports = __webpack_public_path__ + "assets/2a6f4d3aee608502bca278cafc5453f3.png";